import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Extras} from '../models/extras.enum';
import {ProjectService} from '../services/project.service';

@Injectable({
  providedIn: 'root'
})
export class ListeGuard implements CanActivate {

  constructor(private _projectService: ProjectService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._projectService.getServicesFromProject().pipe(
      map(e => {
        let hasListe = false;
        e.forEach(x => {
          if (x.service_code === Extras.SERVIZI_DIGITALI_LISTE_IN_VIAGGIO) {
            hasListe = true;
          }
        });
        return hasListe;
      })
    );
  }

}
